var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('h1',{staticClass:"top-title"},[_vm._v("Apps Manager")]),_c('AppButton',{on:{"click":_vm.addAppClick}},[_vm._v("+ Adicionar app")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }